import { Dialog, DialogContent, DialogTitle } from '@mui/material'

function RulesDialog({ open, onClose, gameType }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: '#221c24',
          color: '#f3eadf',
          border: '1px solid rgba(255,255,255,0.16)',
          borderRadius: '18px',
          boxShadow: '0 24px 60px rgba(0, 0, 0, 0.55)',
        },
      }}
      BackdropProps={{
        sx: {
          backdropFilter: 'blur(8px)',
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
        },
      }}
    >
      <DialogTitle className="settings-dialog-title">Regler</DialogTitle>
      <DialogContent className="yatzy-rules">
        <p>I kaster med rigtige terninger. Appen er scorearket og siger, hvis tur det er.</p>
        <h3>Et kast</h3>
        <p>Kast alle terninger. Gem dem, du vil bruge, og kast resten. I må kaste tre gange i alt. Felterne udfyldes i den rækkefølge, I selv vælger. Efter ét felt er det næste spillers tur.</p>
        <p>En terning, der ligger oven på en anden, skråt eller på gulvet, kastes om.</p>
        <h3>Øvre del</h3>
        <p>1’ere til 6’ere giver summen af de terninger, der tæller med. 63 point eller mere i den øvre del giver 50 point i bonus. Med 6 terninger er bonusgrænsen 84.</p>
        <h3>Nedre del</h3>
        <ul>
          <li>1 par og 2 par: summen af parrene.</li>
          <li>3 ens og 4 ens: summen af de ens terninger.</li>
          <li>Lille straight, 1-2-3-4-5: 15 point.</li>
          <li>Stor straight, 2-3-4-5-6: 20 point.</li>
          <li>Hus, tre ens og et par: summen af alle terningerne.</li>
          <li>Chance: summen af alle terningerne.</li>
          <li>Yatzy, fem ens: 50 point.</li>
        </ul>
        {gameType === 'sixDice' ? (
          <>
            <h3>6 terninger</h3>
            <ul>
              <li>3 par: summen af de tre par.</li>
              <li>2×3 ens: summen af begge sæt.</li>
              <li>Royal, 1-2-3-4-5-6: 30 point.</li>
            </ul>
          </>
        ) : null}
        <h3>Kan kastet ikke bruges</h3>
        <p>Så skal der stå 0 i et ledigt felt. Det tæller som brugt, og turen går videre.</p>
        <p className="yatzy-rules-source">
          Reglerne følger den almindelige Yatzy og er skrevet efter{' '}
          <a href="https://spilregler.dk/yatzy/" target="_blank" rel="noopener noreferrer">spilregler.dk</a>.
        </p>
        <button type="button" className="yatzy-rules-close" onClick={onClose}>Luk</button>
      </DialogContent>
    </Dialog>
  )
}

export default RulesDialog
